/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-note.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel Note',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.375 10C7.375 7.44568 9.44568 5.375 12 5.375H36C38.5543 5.375 40.625 7.44568 40.625 10V35C40.625 35.2364 40.4938 35.4421 40.3002 35.5483L33.5483 42.3002C33.4421 42.4938 33.2364 42.625 33 42.625H12C9.44568 42.625 7.375 40.5543 7.375 38V10ZM33.625 40.5265L38.5265 35.625H37C35.136 35.625 33.625 37.136 33.625 39V40.5265ZM39.375 10V34.375H37C34.4457 34.375 32.375 36.4457 32.375 39V41.375H12C10.136 41.375 8.625 39.864 8.625 38V10C8.625 8.13604 10.136 6.625 12 6.625H36C37.864 6.625 39.375 8.13604 39.375 10ZM15 16.375C15 16.0298 15.2798 15.75 15.625 15.75H32.375C32.7202 15.75 33 16.0298 33 16.375C33 16.7202 32.7202 17 32.375 17H15.625C15.2798 17 15 16.7202 15 16.375ZM15.625 20.75C15.2798 20.75 15 21.0298 15 21.375C15 21.7202 15.2798 22 15.625 22H32.375C32.7202 22 33 21.7202 33 21.375C33 21.0298 32.7202 20.75 32.375 20.75H15.625ZM15 26.375C15 26.0298 15.2798 25.75 15.625 25.75H32.375C32.7202 25.75 33 26.0298 33 26.375C33 26.7202 32.7202 27 32.375 27H15.625C15.2798 27 15 26.7202 15 26.375ZM15.625 30.75C15.2798 30.75 15 31.0298 15 31.375C15 31.7202 15.2798 32 15.625 32H25.375C25.7202 32 26 31.7202 26 31.375C26 31.0298 25.7202 30.75 25.375 30.75H15.625Z"
            fill="#333333"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
